export interface RoutineDeleteRequest {
  routineId: string;
}
export const routineDelete = createAsyncThunk(
  "routineDelete",
  async (param: RoutineDeleteRequest, thunkAPI) => {
    console.debug("delete routine");
    const response = await fetch(`${getBackendUrl()}/api/routine/${param.routineId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      }
    });
    if(response.ok) {
      return { routineId: param.routineId };
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse, INVALID_ID } from "../common";
import { RoutineInfo } from "./routineSlice";
import { getToken } from "../../features/user/UserAvatar";

export interface RoutineInsUptState {
  state: LoadStateInfo;
  routine: RoutineInfo;
}

const initialState: RoutineInsUptState = {
  state: notStarted(),
  routine: emptyRoutine(),
};

function emptyRoutine() {
  return {
    id: INVALID_ID,
    name: "",
    year: `${new Date().getFullYear()}`,
    url: `${getImagesUrl()}/default/routine.webp`,
    schoolId: "",
  };
}

export interface RoutineInsertRequest {
  routine: RoutineInfo;
}
export const routineInsert = createAsyncThunk(
  "routineInsert",
  async (param: RoutineInsertRequest, thunkAPI) => {
    console.debug("insert routine");
    const response = await fetch(`${getBackendUrl()}/api/routine`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routine)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface RoutineUpdateRequest {
  routineId: string;
  routine: RoutineInfo;
}
export const routineUpdate = createAsyncThunk(
  "routineUpdate",
  async (param: RoutineUpdateRequest, thunkAPI) => {
    console.debug("update routine");
    const response = await fetch(`${getBackendUrl()}/api/routine/${param.routineId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routine)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const routineInsUpdSlice = createSlice({
  name: "routineInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<RoutineInfo>) => {
      state.state = notStarted();
      state.routine = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.routine = emptyRoutine();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(routineInsert.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(routineInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.routine = action.payload;
      })
      .addCase(routineInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(routineUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(routineUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.routine = action.payload;
      })
      .addCase(routineUpdate.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(routineDelete.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(routineDelete.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.routine = emptyRoutine();
      })
      .addCase(routineDelete.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = routineInsUpdSlice.actions;

export const selectRoutineInsUpd = (state: RootState) => state.routineInsUpd;

export default routineInsUpdSlice.reducer;
